import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TimeService } from '@bayclubs/utils';
import { camps } from '../../../../models/models.generated';
import { CampCareBookingsCalendarEventService } from '../camp-care-bookings-calendar-event.service';



@Component({
    selector: 'app-camp-care-booking-calendar-nav',
    templateUrl: './camp-care-booking-calendar-nav.component.html',
    styleUrls: ['./camp-care-booking-calendar-nav.component.scss'],
    standalone: false
})
export class CampCareBookingCalendarNavComponent implements OnInit {

    @Input()
    public calendarData: camps.CampCareBookingCalendarData;

    @Input()
    public searchForm: UntypedFormGroup;

    constructor(private eventService: CampCareBookingsCalendarEventService
        , private time: TimeService) { }

    ngOnInit() {
    }

    public onChangeSelectedAge(): void{
        this.eventService.onRefreshCalendar();
    }

    public get firstDay(): camps.CampCareBookingCalendarDay {
        return this.calendarData.days[0];
    }

    public get lastDay(): camps.CampCareBookingCalendarDay {
        return this.calendarData.days[this.calendarData.days.length - 1];
    }

    public onNextWeek(): void {
        let days = 7;

        let firstDayAsMoment = this.time.toMoment(this.firstDay.date);
        let calculatedFirstDay = this.time.addDays(firstDayAsMoment, days);
        let calculatedLastDay = this.time.addDays(calculatedFirstDay, days);

        this.searchForm.controls['dateFrom'].setValue(calculatedFirstDay.format('YYYY-MM-DD'));
        this.searchForm.controls['dateTo'].setValue(calculatedLastDay.format('YYYY-MM-DD'));

        this.eventService.onRefreshCalendar();
    }

    public onPreviousWeek(): void {
        let days = -7;

        let lastDayAsMoment = this.time.toMoment(this.lastDay.date);
        let calculatedLastDay = this.time.addDays(lastDayAsMoment, days);
        let calculatedFirstDay = this.time.addDays(calculatedLastDay, days);

        this.searchForm.controls['dateFrom'].setValue(calculatedFirstDay.format('YYYY-MM-DD'));
        this.searchForm.controls['dateTo'].setValue(calculatedLastDay.format('YYYY-MM-DD'));

        this.eventService.onRefreshCalendar();
    }
}
